import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { financialConditionGenerationStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/styles.ts';

interface IFinancialConditionTableProps {
  ariaLabel: string;
  headers: string[];
  children: React.ReactNode;
  footer?: React.ReactNode;
  showActions?: boolean;
  columnWidths?: string[];
  dateColumnIndexes?: number[];
  minWidth?: number;
}

const DATE_COLUMN_WIDTH = 192;

export const FinancialConditionTable: React.FC<IFinancialConditionTableProps> = ({
  ariaLabel,
  headers,
  children,
  footer,
  showActions = true,
  columnWidths,
  dateColumnIndexes,
  minWidth,
}) => (
  <TableContainer sx={financialConditionGenerationStyles.editableTableContainer}>
    <Table
      aria-label={ariaLabel}
      sx={{
        ...financialConditionGenerationStyles.editableTable,
        ...(minWidth ? { minWidth } : {}),
      }}
    >
      {columnWidths && (
        <colgroup>
          {columnWidths.map((width, index) => (
            <col
              key={`${width}-${index}`}
              style={{ width: dateColumnIndexes?.includes(index) ? DATE_COLUMN_WIDTH : width }}
            />
          ))}
          {showActions && <col style={{ width: 48 }} />}
        </colgroup>
      )}
      <TableHead>
        <TableRow>
          {headers.map((header) => (
            <TableCell key={header} sx={financialConditionGenerationStyles.editableTableHeaderCell}>
              {header}
            </TableCell>
          ))}
          {showActions && (
            <TableCell sx={financialConditionGenerationStyles.editableTableActionCell} />
          )}
        </TableRow>
      </TableHead>
      <TableBody>{children}</TableBody>
      {footer}
    </Table>
  </TableContainer>
);
